<template>
	<div style="padding: 20px 0 20px 0;">
		<el-button type="primary" @click="goBack">返回</el-button>
		<h3>付款信息</h3>
		<el-table :data="info" style="width: 100%" border>
			<el-table-column prop="serialNum" label="交易流水号"></el-table-column>
			<el-table-column prop="name" label="付款方名称"></el-table-column>
			<el-table-column prop="dateTimes" label="日期"></el-table-column>
			<el-table-column prop="amount" label="金额"></el-table-column>


			<el-table-column prop="shopNum" label="商铺编号"></el-table-column>

			<el-table-column prop="reconciled" label="已对账金额"></el-table-column>
			<el-table-column prop="surplus" label="未对账金额"></el-table-column>
			<el-table-column prop="state" label="对账状态">
				<template slot-scope="{row}">
					{{row.state==1?'未对账':'已对账'}}
				</template>
			</el-table-column>
		</el-table>
		<el-form :inline="true" style="margin-top: 20px;" :model="selectForm" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="商铺号">
						<el-input v-model="selectForm.shopNum" placeholder="商铺号" clearable></el-input>
					</el-form-item>
					<el-form-item label="缴费类型">
						<el-select v-model="selectForm.type">
							<el-option label="租金" value="1"></el-option>
							<el-option label="水费" value="2"></el-option>
							<el-option label="电费" value="3"></el-option>
							<el-option label="物业费" value="4"></el-option>
							<el-option label="其他" value="5"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开始时间">
						<el-date-picker v-model="selectForm.startTime" type="date" placeholder="开始时间" style="width: 150px;">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="结束时间">
						<el-date-picker v-model="selectForm.endTime" type="date" placeholder="结束时间" style="width: 150px;">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll()">查询</el-button>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<el-table :data="formDate"  @selection-change="handleSelectionChange" style="width: 100%" height="400" border>
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="shopNum" label="商铺号"></el-table-column>
			<el-table-column prop="shopName" label="商铺名称"></el-table-column>
			<el-table-column prop="type" label="缴费类型"></el-table-column>
			<el-table-column prop="amount" label="应缴金额"></el-table-column>
			<el-table-column prop="state" label="缴费状态">

			</el-table-column>
		</el-table>
		<el-button type="primary" @click="goDz">开始对账</el-button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				info: [],
				selectForm: {
					shopNum: null,
					startTime:null,
					endTime:null,
					type:null
				},
				formDate: [],
				paymentBillVos:[]
			}
		},
		methods: {
			goDz(){
				this.$http.post("/api/reconciliation/reconciliation",{
					id:this.info[0].id,
					paymentBillVos:this.paymentBillVos
				}).then(res=>{
					this.$message(res.data.message)
					this.getAll()
					console.log(res)
				})
			},
			handleSelectionChange(val) {
			       
					this.paymentBillVos=val
					 console.log(this.paymentBillVos)
			      },
			goBack() {
				this.$router.go(-1)
			},
			getAll() {
				this.$http.get("/api/reconciliation/getPaymentBills", {
					params: {
						...this.selectForm
					}
				}).then(res => {
					console.log(res)
					this.formDate = res.data.data
				})
			}
		},
		mounted() {

			var a = this.$route.params.obj
			this.info.push(a)
			console.log(this.info)
			this.getAll()
		}
	}
</script>

<style scoped="scoped">
</style>
